import { Anchor, Box, Group, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { CookieBanner } from '@/components/Ui/Elements/CookieBanner';
import { TermsOfServiceModal } from '@/components/Ui/Elements/TermsOfServiceModal';
import { COMMIT_ID, PRIVACY_POLICY_URL, VERSION } from '@/utils/constant';

export const Footer = () => {
  const v = `v ${VERSION}.${COMMIT_ID?.slice(0, 7)}`;
  const currentYear = new Date().getFullYear();
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Box pos="fixed" bottom={0} w="100vw" h="20px" bg="rgba(255, 255, 255, 0.8)">
        <Group px={16} position="right" h="100%" w="100%" align="center" spacing={8}>
          <Text
            c="rgba(138, 138, 138, 1)"
            fz={10}
            fw={500}
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={open}
          >
            利用規約
          </Text>
          <Anchor
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            c="rgba(138, 138, 138, 1)"
            fz={10}
            fw={500}
            style={{ textDecoration: 'underline' }}
          >
            プライバシーポリシー
          </Anchor>
          <Text c="rgba(138, 138, 138, 1)" fz={10} fw={500}>
            ©{currentYear} Topcon Sokkia Positioning Japan Co.,Ltd.
          </Text>
          <Text c="rgba(138, 138, 138, 1)" fz={10} fw={500}>
            {v}
          </Text>
        </Group>
      </Box>
      <TermsOfServiceModal opened={opened} onClose={close} />
      <CookieBanner bottomOffset="20px" />
    </>
  );
};
